<template>
    <div 
      class="grid-cell"
      v-bind:class="{ 'cell-completed': status=='completed', 'cell-pending': status=='pending', 'cell-disabled': status=='', 'cell-none': icon=='' }"
      @click="DisplayCellInfo(name, status, modified)"
    >
      <img class ='icons-tracking' :src="icon_url" />
      <span v-if="text!=''" class="icon-text">{{ text }}</span>

      <div class="tracking-line"
        v-bind:class="{ 
          'tl-completed': status=='completed', 
          'tl-pending': status=='pending', 
          'tl-disabled': status=='',
          'tl-width-1': line_horizontal=='1',
          'tl-width-2': line_horizontal=='2',
          'tl-width-3': line_horizontal=='3',
          'tl-width-4': line_horizontal=='4',
          'tl-width-5': line_horizontal=='5',
          'tl-width-negative-1': line_horizontal=='-1',
          'tl-width-negative-3': line_horizontal=='-3',
          'tl-height-1': line_vertical=='1',
          'tl-height-2': line_vertical=='2',
          'tl-height-3': line_vertical=='3',
          'tl-height-4': line_vertical=='4'
        }"
      >
      </div>

    </div>
</template>

<script>
import { formatDate } from '@/services/helper'

export default {
  name: 'TrackingCell',
  props: ['stage', 'id', 'icon', 'text', 'status', 'name', 'modified', 'line_horizontal', 'line_vertical'],
  data(){
    return {
      icon_url: ''
    }
  },
  beforeMount () {
    if(this.icon != ''){
      this.icon_url = require('@/assets/icons/icons-tracking/icon-tracking-' + this.icon + '.svg')
    }
  },
  methods: {
    DisplayCellInfo: function (name, status, modified) {     
      this.$parent.$parent.DisplayCellInfo(name, status, formatDate(modified));
    }
  }
}
</script>

<style lang= "scss" scoped>
  .grid-cell {
    color: #fff;
    border-radius: 5px;
    padding: 3px;
    font-size: 150%;
    height: 50px;
    width: 50px;;
    justify-self: center;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .cell-completed {
    background-color: #32AC91;
    cursor: pointer;
  }
  .cell-pending {
    background-color: #00B1FF;
    cursor: pointer;
  }
  .cell-disabled {
    background-color: #D0D0D0;
    cursor: pointer;
  }
  .cell-none {
    background-color: rgba(0,0,0,0);
  }
  .icons-tracking {
    height: 55%;
  }
  .icon-text {
    font-size: 0.6em;
    margin-top: -1px;
  }
  .tracking-line {
    position: absolute;
    z-index: -10;
  }
  .tl-width-1{  
    width: 17%;
    margin-left: 17%;
  }
  .tl-width-2{  
    width: 33%;
    margin-left: 33%;
  }
  .tl-width-3{  
    width: 50%;
    margin-left: 50%;
  }
  .tl-width-4{  
    width: 67%;
    margin-left: 67%;
  }
  .tl-width-5{  
    width: 83%;
    margin-left: 83%;
  }
  .tl-width-negative-1{  
    width: 17%;
    margin-left: -17%;
  }
  .tl-width-negative-3{  
    width: 50%;
    margin-left: -50%;
  }
  .tl-height-1{
    height: 80px;
    margin-top: 80px;
  }
  .tl-height-2{
    height: 160px;
    margin-top: 160px;
  }
  .tl-height-3{
    height: 240px;
    margin-top: 240px;
  }
  .tl-height-4{
    height: 320px;
    margin-top: 320px;
  }
  .tl-completed {
    border-top: 4px solid #32AC91;
    border-left: 4px solid #32AC91;
  }
  .tl-pending {
    border-top: 4px solid #00B1FF;
    border-left: 4px solid #00B1FF;
  }
  .tl-disabled {
    border-top: 4px solid #D0D0D0;
    border-left: 4px solid #D0D0D0;
  }

</style>
